module.exports = __webpack_public_path__ + "img/stock0.194c6539.png";